import { getCachedToken, getHost } from '../../utils/tokenService';
import { SEARCH_METADATA_API_ENDPOINT } from '../../constants';
import { apiJson } from './api-jsons';

const fetchDataSourcesList = async () => {
  try {
    const token = await getCachedToken();

    const response = await fetch(`${getHost()}${SEARCH_METADATA_API_ENDPOINT}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        ...apiJson,
        metadata: [
          {
            type: 'LOGICAL_TABLE',
          },
        ],
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    const dataSources = data.map((dataSource: any) => ({
      id: dataSource.metadata_id,
      name: dataSource.metadata_name,
      description: dataSource.metadata_header?.description || '',
    }));

    return {
      objects: dataSources,
    };
  } catch (error) {
    return {
      objects: [],
    };
  }
};

export default fetchDataSourcesList;

const fetchDataSourcesListWithSearch = async (search: string) => {
  try {
    const token = await getCachedToken();

    const response = await fetch(`${getHost()}${SEARCH_METADATA_API_ENDPOINT}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        ...apiJson,
        metadata: [
          {
            type: 'LOGICAL_TABLE',
            name_pattern: search.trim(),
          },
        ],
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    const dataSources = data.map((dataSource: any) => ({
      id: dataSource.metadata_id,
      name: dataSource.metadata_name,
      description: dataSource.metadata_header?.description || '',
    }));

    return {
      objects: dataSources,
    };
  } catch (error) {
    return {
      objects: [],
    };
  }
};

export { fetchDataSourcesList, fetchDataSourcesListWithSearch };
